(function(){
  const openBtn = document.querySelector('[data-drawer-open]');
  const drawer = document.querySelector('[data-drawer]');
  const closeBtn = document.querySelector('[data-drawer-close]');
  const backdrop = document.querySelector('[data-drawer-backdrop]');
  function open(){ if(!drawer) return; drawer.classList.add('open'); document.documentElement.style.overflow='hidden'; }
  function close(){ if(!drawer) return; drawer.classList.remove('open'); document.documentElement.style.overflow=''; }
  openBtn && openBtn.addEventListener('click', open);
  closeBtn && closeBtn.addEventListener('click', close);
  backdrop && backdrop.addEventListener('click', close);

  const els = Array.from(document.querySelectorAll('[data-reveal]'));
  if('IntersectionObserver' in window){
    const io = new IntersectionObserver((entries)=>{
      entries.forEach(e=>{ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); }});
    }, {threshold:0.15});
    els.forEach(el=>io.observe(el));
  } else els.forEach(el=>el.classList.add('in'));

  document.querySelectorAll('[data-slider]').forEach(slider=>{
    const track = slider.querySelector('[data-slider-track]');
    const prev = slider.querySelector('[data-slider-prev]');
    const next = slider.querySelector('[data-slider-next]');
    if(!track) return;
    const scrollBy = ()=> Math.min(track.clientWidth*0.9, 420);
    prev && prev.addEventListener('click', ()=>track.scrollBy({left:-scrollBy(), behavior:'smooth'}));
    next && next.addEventListener('click', ()=>track.scrollBy({left:scrollBy(), behavior:'smooth'}));
  });

  document.querySelectorAll('[data-gallery]').forEach(g=>{
    const main = g.querySelector('[data-gallery-main]');
    const mainImg = main && main.querySelector('img');
    const thumbs = Array.from(g.querySelectorAll('[data-thumb]'));
    const lb = document.querySelector('[data-lightbox]');
    const lbImg = lb && lb.querySelector('img');
    const lbClose = lb && lb.querySelector('[data-lightbox-close]');
    const lbPrev = lb && lb.querySelector('[data-lightbox-prev]');
    const lbNext = lb && lb.querySelector('[data-lightbox-next]');
    let current = 0;

    function set(i){
      const t = thumbs[i];
      if(!t || !mainImg) return;
      current = i;
      const src = t.getAttribute('data-src');
      const alt = t.getAttribute('data-alt') || '';
      mainImg.src = src;
      mainImg.alt = alt;
      thumbs.forEach(x=>x.setAttribute('aria-current','false'));
      t.setAttribute('aria-current','true');
      if(lbImg){ lbImg.src = src; lbImg.alt = alt; }
    }

    thumbs.forEach((t,i)=>{
      t.addEventListener('click', ()=>set(i));
      if(i===0) t.setAttribute('aria-current','true');
    });

    main && main.addEventListener('click', ()=>{
      if(!lb || !lbImg || !mainImg) return;
      lbImg.src = mainImg.src;
      lbImg.alt = mainImg.alt;
      lb.classList.add('open');
      document.documentElement.style.overflow='hidden';
    });

    function lbHide(){
      if(!lb) return;
      lb.classList.remove('open');
      document.documentElement.style.overflow='';
    }
    lbClose && lbClose.addEventListener('click', lbHide);
    lb && lb.querySelector('.bg') && lb.querySelector('.bg').addEventListener('click', lbHide);

    document.addEventListener('keydown', (e)=>{
      if(!lb || !lb.classList.contains('open')) return;
      if(e.key==='Escape') lbHide();
      if(e.key==='ArrowLeft') set(Math.max(0,current-1));
      if(e.key==='ArrowRight') set(Math.min(thumbs.length-1,current+1));
    });
    lbPrev && lbPrev.addEventListener('click', ()=>set(Math.max(0,current-1)));
    lbNext && lbNext.addEventListener('click', ()=>set(Math.min(thumbs.length-1,current+1)));

    if(thumbs.length) set(0);
  });
})();
